import type ArticleType from '@gik/blog/models/ArticleType';
import type { APIWithSlug, DeepQueryParams, SWRConfigInterface } from '@gik/core/api/BaseAPIConfig';
import { wpApi } from '@gik/core/api/ky/wpApi';
import { useWPApi } from '@gik/core/api/swr/useWPApi';
import PostsUrlBuilder from './PostsUrlBuilder';

const path = 'article-type';

export interface ArticleTypeParams extends APIWithSlug {}

function getParams(params: ArticleTypeParams): DeepQueryParams {
  // prettier-ignore
  const builder = new PostsUrlBuilder()
  .withSlug(params.slug);

  return builder.params;
}

export function getArticleType(params: ArticleTypeParams) {
  return wpApi
    .get(path, {
      searchParams: getParams(params),
    })
    .json<ArticleType>();
}

export function useArticleType(params: ArticleTypeParams, config?: SWRConfigInterface) {
  return useWPApi<ArticleType>(path, getParams(params), config);
}
